import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { NotificationService } from '@agilent/ui-element';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    private currentComponentCanDeactivate: boolean = true;

    constructor(
        private notificationService: NotificationService
    ) {
    }

    canDeactivate(component: CanComponentDeactivate,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {
            if (this.currentComponentCanDeactivate === false) {
                this.notificationService.warning(
                    'There is a task still in progress.');
            }
            return this.currentComponentCanDeactivate;
    }

    setCurrentComponentCanDeactivate(isAllowed: boolean) {
        this.currentComponentCanDeactivate = isAllowed;
    }
}
